import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputComponent from '../../components/input/input.component';
import * as yup from 'yup';
import ButtonPrimary from '../../components/button-refactor/button-primary';
import ErrorValidateComponent from '../../components/error-validate/error-validate.component';
import { authenticationServices } from '../../services/authentication.service';
import { routePaths } from '../../routes/routes-path';
import { useNavigate } from 'react-router-dom';
import { LocalStorageService } from '../../configuration';
import toast from 'react-hot-toast';
import { mapAdminLoginError } from '../../utils/admin-login-error';

const adminLoginSchema = yup.object({
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
});

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(adminLoginSchema),
  });

  const onSubmit = async (payload) => {
    if (loading) return; // chống bấm liên tục khi đang chờ
    setLoading(true);
    try {
      const res = await authenticationServices.adminLogin(payload);
      // Nếu 2FA bị TẮT tạm (BE trả token luôn) → lưu token & vào admin.
      // Ngược lại → sang bước nhập mã OTP (email).
      if (res?.token?.accessToken) {
        LocalStorageService.setItem('cmsAccessToken', res.token.accessToken);
        LocalStorageService.setItem('cmsFingerprintHash', res.token.fingerprintHash);
        LocalStorageService.setItem('cmsRefreshToken', res.token.refreshToken);
        navigate(routePaths.admin);
      } else {
        navigate(`/admin/two-factor/${payload.email}`);
      }
    } catch (error) {
      toast.error(mapAdminLoginError((error as any)?.response?.data?.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-full px-5 lg:px-0 mx-auto py-8">
          <div className="rounded-md bg-slate-50 dark:bg-zinc-800 max-w-md mx-auto p-6 shadow-lg">
            <h2 className="text-3xl font-bold mb-8 text-center">
              Đăng nhập Admin
            </h2>
            <form
              className="flex flex-col gap-4"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div>
                <label
                  className="block font-medium text-sm mb-2 "
                  htmlFor="email"
                >
                  Email
                </label>
                <InputComponent
                  register={register('email')}
                  id="email"
                  type="email"
                  name="email"
                />
                <ErrorValidateComponent visible={!!errors.email}>
                  {errors.email?.message}
                </ErrorValidateComponent>
              </div>
              <div>
                <label
                  className="block font-medium text-sm mb-2 "
                  htmlFor="password"
                >
                  Mật khẩu
                </label>
                <InputComponent
                  register={register('password')}
                  id="password"
                  type="password"
                  name="password"
                />
                <ErrorValidateComponent visible={!!errors.password}>
                  {errors.password?.message}
                </ErrorValidateComponent>
              </div>
              <ButtonPrimary
                type="submit"
                loading={loading}
                disabled={loading}
                className="w-full justify-center"
              >
                {loading ? 'Đang đăng nhập…' : 'Đăng nhập'}
              </ButtonPrimary>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
